import React, {ChangeEvent} from 'react';

import {LetterGrade} from '../constants';
import {select} from '../sharedStyles';

type Props = Readonly<{
  inputID: string;
  value: LetterGrade | null;
  onChange: (grade: LetterGrade | null) => void;
}>;
export default function LetterGradeSelector(props: Props) {
  return (
    <select
      className={select}
      id={props.inputID}
      value={String(props.value || '')}
      onChange={(evt: ChangeEvent<HTMLSelectElement>) => {
        const value = evt.target.value;
        props.onChange(
          value === '' ? null : LetterGrade[value as keyof typeof LetterGrade],
        );
      }}>
      <option value="" />
      <option value="A">A</option>
      <option value="B">B</option>
      <option value="C">C</option>
      <option value="D">D</option>
      <option value="E">E</option>
    </select>
  );
}
